import { Icon } from './common-class';

export class PaymentsTypesClass {
  idPaymentsTypes: number | null = null;
  // Name: string = '';
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Days: number | null = null;
  Icon: Icon | null = null;
  ShowNIB: boolean = false;
  LibertyCode: string = '';
  RealVidaCode: string = '';
  idAGEAS: string = '';
  idTranquilidade: string = '';
  SabSeg: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class ProductsProposalsPaymentsSplitClass {
  idProductsTypesProposalsPaymentsSplit: number | null = null;
  idProductsTypesProposalsFilter: number | null = null;
  idProductsTypesProposals: number | null = null;
  idPaymentsTypes: number | null = null;
  PaymentsTypesDescription: string = '';
  PaymentsTypesLibertyCode: string = '';
  PaymentsTypesRealVidaCode: string = '';
  idPaymentsSplit: number | null = null;
  PaymentsSplitDescription: string = '';
  PaymentsSplitLibertyCode: string = '';
  PaymentsSplitRealVidaCode: string = '';
  Price: any = '';
  PriceText: string = '';
  DateStart: string = '';
  DateEnd: Date | null = null;
  Default: boolean = false;
  suggest: boolean = false;
  Order: number | null = null;
  Description: string = '';
  disable: boolean = false;
  path: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class PaymentsSplitClass {
  idPaymentsSplit: number | null = null;
  Description: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Days: number | null = null;
  ValueText: string = '';
  Value: number | null = null;
  Order: number | null = null;
  LibertyCode: string = '';
  RealVidaCode: string = '';
  HideMessageCenterQuiz: boolean = false;
  idAGEAS: string = '';
  idTranquilidade: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}
